import { render, staticRenderFns } from "./external-link-button.vue?vue&type=template&id=0d667bd1&"
import script from "./external-link-button.vue?vue&type=script&lang=ts&"
export * from "./external-link-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports